import { Box, Typography, Divider } from '@mui/material';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/en';

dayjs.extend(calendar);
dayjs.extend(localizedFormat);
dayjs.extend(timezone);

interface DateDividerProps {
    date: string;
}

export default function DateDivider({ date }: DateDividerProps) {
    const dateLabel = dayjs(date).tz(dayjs.tz.guess()).calendar(null, {
        sameDay: '[Today]',
        lastDay: '[Yesterday]',
        lastWeek: 'dddd, MMMM DD',
        sameElse: 'MMMM DD, YYYY',
    });

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                paddingY: 2.5,
                paddingX: 3,
            }}>
            <Divider sx={{ flexGrow: 1, borderColor: 'cement.200' }} />
            <Box
                sx={{
                    px: 2,
                    py: 0.5,
                    borderRadius: '16px',
                    border: '1px solid',
                    borderColor: 'cement.200',
                    display: 'inline-flex',
                    alignItems: 'center',
                }}>
                <Typography variant="body2" fontSize="0.813rem" color="cement.500" fontWeight={400}>
                    {dateLabel}
                </Typography>
            </Box>
            <Divider sx={{ flexGrow: 1, borderColor: 'cement.200' }} />
        </Box>
    );
}
